module.exports = "<div class=\"container-fluid my-3\">\n    <ui-view></ui-view>\n</div>"